import Users from "../components/views/users/Users.vue";
import AddCity from "../components/views/city/addCity.vue";
import City from "../components/views/city/city.vue";
import CityPassword from "../components/views/city/cityPassword.vue";

const routes = [
  {
    path: "city",
    component: City,
    name: "city",
    meta: {
      // description: "List of Cities",
      title: "City",
      requiresAuth: true,
    },
  },
  {
    path: "city/createCity/:_id",
    component: AddCity,
    name: "addCity",
    meta: {
      // description: 'Add a new City',
      title: "Add / Update City",
      requiresAuth: true,
    },
  },
  {
    path: "city/cityPassword",
    component: CityPassword,
    name: "cityPassword",
    meta: {
      // description: "Change City Password",
      title: "Change City Password",
      requiresAuth: true,
    },
    props: true,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/city.route.js